import { useRef } from 'react';
import { ArrowDownTrayIcon, ShareIcon } from '@heroicons/react/20/solid';
import { toBlob, toPng } from 'html-to-image';
import { formatDate } from '../../../../../lib/date';
import shareBg1 from '../../../../../assets/jpg/complete-1.jpg';
import shareBg2 from '../../../../../assets/jpg/complete-2.jpg';
import shareBg3 from '../../../../../assets/jpg/complete-3.jpg';

const getBackground = (randomIndex) => {
  return [shareBg1, shareBg2, shareBg3][randomIndex];
};

const CompleteStamp = ({
  challengeTitle,
  workoutTitle,
  selectedDay,
  randomIndex = Math.floor(Math.random() * 3),
}) => {
  const shareRef = useRef(null);

  const handleShare = async () => {
    const newFile = await toBlob(shareRef.current, { quality: 1 });
    const data = {
      files: [
        new File([newFile], 'share_img.png', {
          type: newFile.type,
        }),
      ],
      title: challengeTitle,
      text: challengeTitle,
    };

    try {
      if (navigator.canShare(data)) {
        await navigator.share(data);
        return;
      }
      console.error("Can't share");
    } catch (err) {
      console.error(err);
    }
  };

  const handleDownload = async () => {
    try {
      const dataUrl = await toPng(shareRef.current, { quality: 1 });
      const link = document.createElement('a');
      link.download = 'share_img.png';
      link.href = dataUrl;
      link.click();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className='relative rounded-xl border border-tertiary'>
      <div
        ref={shareRef}
        className='relative text-white overflow-hidden rounded-xl'
      >
        <img
          src={getBackground(randomIndex)}
          alt='share'
          className='object-contain rounded-xl'
        />
        <div className='absolute top-1/3 left-1/2 -translate-x-1/2 w-full p-4'>
          <div className='font-bold text-xs'>
            {new Date().getFullYear()} {challengeTitle}
          </div>
          <div className='font-bold'>{workoutTitle} completed!</div>
          <div className='text-[8px] leading-3'>
            {selectedDay ?? formatDate(new Date())}
          </div>
        </div>
        <div className='absolute bottom-0 left-0 w-full p-4 flex justify-between items-center text-[10px] opacity-40'>
          <div className='font-bold italic'>#TheChamps</div>
          <div className='font-bold italic'>@David Park</div>
        </div>
      </div>
      <div className='absolute top-0 p-2 w-full flex gap-4 items-center justify-end'>
        <button onClick={handleShare}>
          <ShareIcon className='size-6 text-white' />
        </button>
        <button onClick={handleDownload}>
          <ArrowDownTrayIcon className='size-6 text-white' />
        </button>
      </div>
    </div>
  );
};

export default CompleteStamp;
